import { Skeleton, tv } from "@tournated-com/ui";

const countBadgeVariants = tv({
  base: [
    "flex items-center justify-center",
    "bg-tone-3",
    "group-selected:bg-brand-2",
    "preset-label-sm text-light-primary",
    "min-w-4 rounded-full py-0.5 px-1.5",
    "transition-all duration-150",
  ],
});

export type CountBadgeProps = {
  count: number;
  isLoading?: boolean;
};

export const CountBadge = ({ count, isLoading = false }: CountBadgeProps) => {
  if (isLoading) {
    return <Skeleton className="w-4 h-4 min-w-4 rounded-full p-1" />;
  }

  return <div className={countBadgeVariants()}>{count}</div>;
};
